export default {
      id: "contacts_pr-usage",
      viewBox: "0 0 41 40",
      url: __webpack_public_path__ + "sprite.svg#contacts_pr",
      toString: function () {
        return this.url;
      }
    }